import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class DataTransferService {
    private updateUserProfileData: BehaviorSubject<any> = new BehaviorSubject(
        ''
    );
    private refreshGrid: Subject<any> = new Subject();
    private capsuleRowHeightForGrid = new Subject<any>();
    private updateSecondaryMenuCount: Subject<any> = new Subject();
    private filterUpdateApi: Subject<any> = new Subject();
    private changedModule: Subject<any> = new Subject();
    private redirectMpConnection: Subject<any> = new BehaviorSubject<any>('');
    private integratedMarketplacesData: BehaviorSubject<any> =
        new BehaviorSubject('');
    private dashboardRangeData: BehaviorSubject<any> = new BehaviorSubject('');
    private omsAccess: Subject<any> = new Subject();
    private currentPageForPagination = new Subject<any>();
    private selectedMarketplaceName: BehaviorSubject<any> = new BehaviorSubject(
        ''
    );
    private filterOptions: Subject<any> = new Subject();
    private brandingLogo: BehaviorSubject<any> = new BehaviorSubject('');
    private dashboardColors: Subject<any> = new Subject();

    public updateSecondaryMenuCount$ =
        this.updateSecondaryMenuCount.asObservable();
    public updateUserProfileData$ = this.updateUserProfileData.asObservable();
    public refreshGrid$ = this.refreshGrid.asObservable();
    public capsuleRowHeightForGrid$ =
        this.capsuleRowHeightForGrid.asObservable();
    public filterUpdateApi$ = this.filterUpdateApi.asObservable();
    public changedModule$ = this.changedModule.asObservable();
    public redirectMpConnection$ = this.redirectMpConnection.asObservable();
    public integratedMarketplacesData$ =
        this.integratedMarketplacesData.asObservable();
    public dashboardRangeData$ = this.dashboardRangeData.asObservable();
    public omsAccess$ = this.omsAccess.asObservable();
    public currentPageForPagination$ =
        this.currentPageForPagination.asObservable();
    public selectedMarketplaceName$ =
        this.selectedMarketplaceName.asObservable();
    public filterOptions$ = this.filterOptions.asObservable();
    public brandingLogo$ = this.brandingLogo.asObservable();
    public dashboardColors$ = this.dashboardColors.asObservable();
    resetSelections$: Subject<any> = new Subject();
    public sendConfData: BehaviorSubject<any> = new BehaviorSubject('');
    public sendConfData$ = this.sendConfData.asObservable();

    private globalSearch: BehaviorSubject<any> = new BehaviorSubject('');
    public globalSearch$ = this.globalSearch.asObservable();

    public sendproblemData: BehaviorSubject<any> = new BehaviorSubject('');
    public sendproblemData$ = this.sendproblemData.asObservable();
    private currentselectedPartnersData = new BehaviorSubject<any>('');
    public currentselectedPartnersData$ =
        this.currentselectedPartnersData.asObservable();
    private sendenableflag: BehaviorSubject<any> = new BehaviorSubject('');
    public sendenableflag$ = this.sendenableflag.asObservable();
    private sendSellerStoreId: BehaviorSubject<any> = new BehaviorSubject('');
    public sendSellerStoreId$ = this.sendSellerStoreId.asObservable();
    private sendDeliveryOnly: BehaviorSubject<{ delivery_only: boolean } | ''> =
        new BehaviorSubject('');
    public sendDeliveryOnly$ = this.sendDeliveryOnly.asObservable();
    sendUserProfileData(data) {
        this.updateUserProfileData.next(data);
    }
    refresh_grid(data: any) {
        this.refreshGrid.next(data);
    }
    resetSelection(reset) {
        this.resetSelections$.next(reset);
    }
    sendCapsuleRowHeightToGrid(data: any) {
        this.capsuleRowHeightForGrid.next(data);
    }
    updateSecondaryMenuCounts(type) {
        if (
            type?.toLowerCase() === 'orders' &&
            this.shouldDeferOrderMenuCounts()
        ) {
            return;
        }
        this.updateSecondaryMenuCount.next(type);
    }

    private static readonly ORDER_BULK_ACTIVITY_COUNT_WAIT_MS = 1000;

    private orderBulkActivityCountDeferralTimer: ReturnType<
        typeof setTimeout
    > | null = null;
    private isOrderBulkActivityCountDeferralActive = false;
    private orderBulkActivityCountsReleased = false;
    private activeBulkProgressPollCount = 0;

    /**
     * Blocks order count APIs before navigating to order/bulkactivity. Counts
     * are released after the wait window if bulk_progress never starts, or
     * after all bulk_progress polls reach 100%.
     */
    prepareOrderBulkActivityNavigation(): void {
        this.startOrderBulkActivityCountDeferral();
    }

    private startOrderBulkActivityCountDeferral(): void {
        if (this.isOrderBulkActivityCountDeferralActive) {
            return;
        }

        this.clearOrderBulkActivityCountDeferralTimer();
        this.isOrderBulkActivityCountDeferralActive = true;
        this.orderBulkActivityCountsReleased = false;
        this.activeBulkProgressPollCount = 0;

        this.orderBulkActivityCountDeferralTimer = setTimeout(() => {
            this.evaluateOrderBulkActivityCountsRelease();
        }, DataTransferService.ORDER_BULK_ACTIVITY_COUNT_WAIT_MS);
    }

    /**
     * Clears deferral state when leaving the order bulk activity page.
     */
    finalizeOrderBulkActivityCountDeferral(): void {
        this.clearOrderBulkActivityCountDeferralTimer();

        if (!this.isOrderBulkActivityCountDeferralActive) {
            return;
        }

        this.isOrderBulkActivityCountDeferralActive = false;

        if (!this.orderBulkActivityCountsReleased) {
            this.releaseOrderBulkActivityCounts('orders');
        }
    }

    shouldDeferOrderMenuCounts(): boolean {
        return this.isOrderBulkActivityCountDeferralActive;
    }

    notifyBulkProgressPollStarted(): void {
        if (!this.isOrderBulkActivityCountDeferralActive) {
            return;
        }
        this.activeBulkProgressPollCount++;
    }

    notifyBulkProgressPollCompleted(moduleType: string): void {
        if (this.activeBulkProgressPollCount > 0) {
            this.activeBulkProgressPollCount--;
        }

        if (
            this.isOrderBulkActivityCountDeferralActive &&
            this.activeBulkProgressPollCount === 0
        ) {
            this.releaseOrderBulkActivityCounts(moduleType);
        }
    }

    cancelBulkProgressPollOnDestroy(): void {
        if (this.activeBulkProgressPollCount > 0) {
            this.activeBulkProgressPollCount--;
        }
    }

    private evaluateOrderBulkActivityCountsRelease(): void {
        if (
            !this.isOrderBulkActivityCountDeferralActive ||
            this.orderBulkActivityCountsReleased
        ) {
            return;
        }

        if (this.activeBulkProgressPollCount === 0) {
            this.releaseOrderBulkActivityCounts('orders');
        }
    }

    private releaseOrderBulkActivityCounts(moduleType: string): void {
        if (this.orderBulkActivityCountsReleased) {
            return;
        }

        this.orderBulkActivityCountsReleased = true;
        this.isOrderBulkActivityCountDeferralActive = false;
        this.clearOrderBulkActivityCountDeferralTimer();
        this.updateSecondaryMenuCount.next(moduleType);
    }

    private clearOrderBulkActivityCountDeferralTimer(): void {
        if (this.orderBulkActivityCountDeferralTimer) {
            clearTimeout(this.orderBulkActivityCountDeferralTimer);
            this.orderBulkActivityCountDeferralTimer = null;
        }
    }
    filterUpdatesApi(data: any) {
        this.filterUpdateApi.next(data);
    }

    changedOrderModule(data: any) {
        this.changedModule.next(data);
    }

    sendRedirectMpConnection(data) {
        this.redirectMpConnection.next(data);
    }

    sendIntegratedMarketplacesData(data) {
        this.integratedMarketplacesData.next(data);
    }

    getDashboardRangeData(data) {
        this.dashboardRangeData.next(data);
    }

    sendOMSAccess(data) {
        this.omsAccess.next(data);
    }

    sendCurrentPageForPagination(data: any) {
        this.currentPageForPagination.next(data);
    }

    sendMarketplaceName(data: string) {
        this.selectedMarketplaceName.next(data);
    }

    filterOption(data: any) {
        this.filterOptions.next(data);
    }

    sendBrandingLogo(data: any) {
        this.brandingLogo.next(data);
    }

    setDashboardColors() {
        this.dashboardColors.next('');
    }
    sendConfDataTo(data) {
        this.sendConfData.next(data);
    }
    globalsearches(data) {
        this.globalSearch.next(data);
    }
    sendproblemDataTo(data) {
        this.sendproblemData.next(data);
    }
    
    private refreshFromRetailer: Subject<any> = new Subject();
    public refreshFromRetailer$ = this.refreshFromRetailer.asObservable();
    updateRefreshFromRetailer(type) {
        this.refreshFromRetailer.next(type);
    }

    private addressBookEditSubject: Subject<any> = new Subject();
    public addressBookEdit$ = this.addressBookEditSubject.asObservable();
    editAddressBook(row: any): void {
        this.addressBookEditSubject.next(row);
    }

    // Pushes the Address Book nav badge from a known list total (avoids a
    // separate getCount() race after create/delete that can leave the badge stale).
    private addressBookCountSubject: Subject<number> = new Subject();
    public addressBookCount$ = this.addressBookCountSubject.asObservable();
    setAddressBookCount(count: number): void {
        this.addressBookCountSubject.next(count);
    }

    sendSelectedPartner(data: any) {
        this.currentselectedPartnersData.next(data);
    }
    sendenableflags(data) {
        this.sendenableflag.next(data);
    }
    sendSellerStoreIdData(data) {
        this.sendSellerStoreId.next(data);
    }

    sendDeliveryOnlyData(data: { delivery_only: boolean }) {
        this.sendDeliveryOnly.next(data);
    }

    private selectedManagedUser: unknown = null;

    setSelectedManagedUser(user: unknown): void {
        this.selectedManagedUser = user;
    }

    consumeSelectedManagedUser<T>(): T | null {
        const user = this.selectedManagedUser as T | null;
        this.selectedManagedUser = null;
        return user;
    }
}
